import { style } from "@vanilla-extract/css";
import { breakpoints } from "plos/src/styles/breakpoints";
import { vars } from "plos/src/styles/theme.css";

export const teamPitchWrap = style({
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr)",
  gap: vars.space.m,
});

export const playerInfoWrap = style({
  display: "flex",
  justifyContent: "center",
  gap: vars.space.s,
  textAlign: "center",
  "@media": {
    [`(min-width: ${breakpoints[4]})`]: {
      display: "none",
    },
  },
});

export const dreamTeamWrap = style({
  display: "flex",
  justifyContent: "center",
  gap: vars.space.m,
});

export const boldLink = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.xs,
  textDecoration: "none",
  color: vars.colors.primary,
  fontFamily: vars.fonts.bold,
});

export const eventHeaderWrapper = style({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: vars.space.m,
  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      marginBottom: 0,
    },
  },
});

export const eventHeading = style({
  display: "flex",
  justifyContent: "center",
});

export const eventPager = style({
  position: "absolute",
  top: 0,
  display: "flex",
  justifyContent: "space-between",
  gap: vars.space.l,
  width: "80%",
  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      width: "50%",
    },
  },
});

const basePagerButton = style({
  width: 34,
  height: 34,
});

export const previousEvent = style([
  basePagerButton,
  {
    justifySelf: "start",
  },
]);

export const nextEvent = style([
  basePagerButton,
  {
    justifySelf: "end",
  },
]);

export const teamTitleWrapper = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.s,
});

export const entryCrestStyles = style({
  "@media": {
    [`(min-width: ${breakpoints[4]})`]: {
      display: "none",
    },
  },
});
